import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import { onMounted, ref, onUnmounted, watch } from "vue";
import { VideoJsPlayer } from "video.js";
import videojs from "video.js/dist/alt/video.core.novtt.js";
import "video.js/dist/video-js.min.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'Player',
  props: {
  src: {
    type: String,
    default() {
      return ""
    }
  },
  id: {
    type: String,
    default: () => ""
  },
  poster: {
    type: String,
    default: () => ""
  },
},
  emits: ['play','pause'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit;

let player = ref<VideoJsPlayer>();
let playStatus = ref<boolean>(false);
watch(
  () => props.src,
  (val) => {
    player.value?.loadMedia({ src: val, type: "video/mp4" }, () => { console.log(1) });
  }
);

const play = () => {
  player.value?.play();
}

const pause = () => {
  player.value?.pause()
}

onMounted(() => {
  player.value = videojs("player" + props.id, {
    autoplay: false,
    controls: true,
    fluid: true,
    aspectRatio: "16:9",
    fill: true,
    sources: [
      {
        src: props.src,
        type: "video/mp4",
      },
    ],
    poster: props.poster,
    playbackRates: [0.5, 1, 1.5, 2],
    userActions: {
      hotkeys: function (event) {
        let currentTime = player.value?.currentTime() as number;
        switch (event.code) {
          case 'ArrowRight':
            player.value?.currentTime(currentTime + 10)
            break;
          case 'ArrowLeft':
            player.value?.currentTime(currentTime < 10 ? 0.1 : currentTime - 10)
            break;
          case 'Space':
            if (event) {
              event.preventDefault();
            }
            playStatus.value ? pause() : play()
            break;
          default:
            break;
        }
      }
    }
  }, function () {
    this.on("play", () => {
      playStatus.value = true;
      emits('play');
    })
    this.on("pause", () => {
      playStatus.value = false;
      emits('pause');
    })
  });
});
onUnmounted(() => {
  player.value?.dispose();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("video", {
    id: 'player' + __props.id,
    class: "video-js vjs-big-play-centered"
  }, null, 8, _hoisted_1))
}
}

})